// Daily Data Collection Bar Chart

import React from "react";
import ReactECharts from "echarts-for-react";

interface DailyDataCollectionBarChartProps {
  reportData: Array<{
    meterId: string;
    expectedReads: number;
    receivedReads: number;
    [key: string]: any;
  }>;
}

const DailyDataCollectionBarChart: React.FC<
  DailyDataCollectionBarChartProps
> = ({ reportData }) => {
  const options = {
    tooltip: {
      trigger: "axis",
      backgroundColor: "#181B25",
      borderWidth: 1,
      borderColor: "#181B25",
      axisPointer: { type: "line" },
      formatter: (params: any) => {
        const [collection] = params;
        return `
          <div style="padding: 5px 10px; border-radius: 3px; color: #ffffff;">
            <b>${collection.axisValue}</b><br/>
            Consumption: ${collection.data}
          </div>
        `;
      },
    },
    xAxis: {
      type: "category",
      data: reportData.map((item) => item.meterId),
      axisLabel: {
        color: "#5F6368",
        fontSize: 10,
        fontWeight: 400,
        lineHeight: 11,
        letterSpacing: 0.2,
      },
    },
    yAxis: [
      {
        type: "value",
        name: "Reads",
        position: "left",
        axisLabel: {
          formatter: "{value}",
          color: "#5F6368",
          fontSize: 10,
          fontWeight: 400,
        },
      },
    ],
    series: [
      {
        name: "Expected Reads",
        type: "bar",
        data: reportData.map((item) => item.expectedReads),
        itemStyle: {
          color: "#1976d2",
        },
        barWidth: "30%",
      },
      {
        name: "Received Reads",
        type: "bar",
        data: reportData.map((item) => item.receivedReads),
        itemStyle: {
          color: "#9CE976",
        },
        barWidth: "30%",
      },
    ],
    grid: {
      left: "3%",
      right: "3%",
      bottom: "20%",
      containLabel: true,
    },
  };
  return <ReactECharts option={options} style={{ height: "350px" }} />;
};

export default DailyDataCollectionBarChart;
